// @ts-ignore

export const CONFIG = {
  adminUrl: process.env.ADMIN_PANEL_URL,
  apiUrl: process.env.API_URL,
  env: process.env.NODE_ENV,
};
